query EmailTemplatesList($search: String, $page: Int, $rowsPerPage: Int) {
  emailTemplates(search: $search, page: $page, rowsPerPage: $rowsPerPage) {
    count
    nodes {
      id
      name
      updatedAt
      variants {
        language
        subject
      }
    }
  }
}
